import { useRef } from 'react'
import { Mic, Send } from 'lucide-react'
import { useT } from '../../i18n/useT'

// Pulsante unico stile WhatsApp:
// - input vuoto     → icona Mic (press-and-hold per registrare, rilascio = stop + invio)
// - input con testo → icona Send (tap per inviare)
//
// Pointer capture: quando l'utente preme il mic, "catturiamo" il pointer sul button
// così i successivi eventi (move/up) vanno SEMPRE al button — anche se il mouse esce
// dai bounds. Senza capture, redraw del DOM / popup di permessi / spostamenti accidentali
// del mouse triggerano pointerleave e fermano la registrazione inaspettatamente.
export default function ChatInput({
  input, setInput,
  listening, loading, speechSupported,
  onSend, onMicPressStart, onMicPressEnd, onKeyDown,
}) {
  const t = useT()
  const hasText = input.trim().length > 0

  const pressStartedRef = useRef(false)
  const pointerIdRef    = useRef(null)

  const handlePointerDown = (e) => {
    if (!speechSupported || loading || hasText) return
    e.preventDefault()
    try {
      // Pointer capture: il button "possiede" il pointer fino al release
      e.currentTarget.setPointerCapture?.(e.pointerId)
      pointerIdRef.current = e.pointerId
    } catch {}
    pressStartedRef.current = true
    onMicPressStart()
  }

  const endPress = (e) => {
    if (!pressStartedRef.current) return
    pressStartedRef.current = false
    try {
      if (pointerIdRef.current != null && e?.currentTarget?.releasePointerCapture) {
        e.currentTarget.releasePointerCapture(pointerIdRef.current)
      }
    } catch {}
    pointerIdRef.current = null
    onMicPressEnd()
  }

  return (
    <div className="chat-input-area">
      <div className="chat-input-row">
        <input
          className="chat-input"
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={onKeyDown}
          placeholder={listening ? t('agent_listening') : t('agent_placeholder')}
          disabled={loading || listening}
        />

        {hasText ? (
          <button
            className="chat-action-btn chat-action-btn--send"
            onClick={() => onSend()}
            disabled={loading || listening}
            aria-label={t('agent_send')}
            type="button"
          >
            <Send size={20} />
          </button>
        ) : (
          <button
            className={`chat-action-btn chat-action-btn--mic${listening ? ' chat-action-btn--recording' : ''}`}
            onPointerDown={handlePointerDown}
            onPointerUp={endPress}
            onPointerCancel={endPress}
            onContextMenu={e => e.preventDefault()}
            disabled={loading || !speechSupported}
            aria-label={t('agent_start_mic')}
            type="button"
          >
            <Mic size={listening ? 24 : 20} />
          </button>
        )}
      </div>

      {listening && (
        <div className="chat-listening-indicator">
          <span className="chat-listening-dot" />
          {t('agent_listening')}
        </div>
      )}
    </div>
  )
}
